import { useSelector } from 'react-redux';
import { selectors } from '../jwtMiddleware/tokenDuck';

export const useToken = () => {
  return useSelector(selectors.token);
};
